import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { Constants } from './../../app.constants';
import { ErrorHandleService } from './error-handle.service';

@Injectable({
    providedIn: 'root',
})
export class FilterService {
    resetFilter$ = new Subject();

    constructor(private http: HttpClient, private errorHandleService: ErrorHandleService, private constants: Constants) {}

    getFilterValues(filterValue): Observable<any> {
        const uri = decodeURIComponent(`${this.constants.apiUrl}/Search/getSearchFilterContent`);
        const config = {
            headers: new HttpHeaders().set('Content-Type', 'application/json'),
        };
        return this.http.post(uri, JSON.stringify(filterValue), config).pipe(
            tap((_) => console.log('fetched filter values')),
            catchError(this.errorHandleService.handleError('filterSamples', [])),
            finalize(() => console.log('Loaded: Filter values'))
        );
    }

    convertArrayToString(inputArray) {
        if (inputArray) {
            return inputArray.join(',');
        } else {
            return '';
        }
    }

    convertList(data) {
        if ((data && data.length == 0) || !data) {
            return null;
        }
        const tempArr = this.uniqBy(data, 'id');
        const mapArr = tempArr.map((item) => {
            return item.id;
        });
        const result = mapArr.join(',');
        return result;
    }

    convertBGList(data) {
        if ((data && data.length == 0) || !data) {
            return null;
        }

        if (data.length == 1) {
            return this.convertList(data);
        }

        const result = data.join(',');
        return result;
    }

    uniqBy = (arr, predicate) => {
        const cb = typeof predicate === 'function' ? predicate : (o) => o[predicate];

        return [
            ...arr
                .reduce((map, item) => {
                    const key = item === null || item === undefined ? item : cb(item);

                    map.has(key) || map.set(key, item);

                    return map;
                }, new Map())
                .values(),
        ];
    };

    resetFilter() {
        this.resetFilter$.next();
    }
}
